import { HTMLAttributes, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToastContentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  render?: ReactNode
}

export function ToastContent({ className, children, render, ...props }: ToastContentProps) {
  return (
    <div className={twMerge('flex w-full select-none flex-col gap-2', className)} {...props}>
      {render ?? children}
    </div>
  )
}
